export default {"src":"/_next/static/media/download-white.a1e18036.svg","height":192,"width":192};